module.exports = __webpack_public_path__ + "img/download-cloud.743d6d35.svg";